import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AppStoreBadge from '@/components/common/AppStoreBadge';
import PlayStoreBadge from '@/components/common/PlayStoreBadge';
import { useTheme } from '@/hooks/useTheme';

export default function GetTheAppPage() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className="relative flex items-center justify-center px-6 py-12 min-h-[100dvh]">
      <div className="relative z-[3] w-full max-w-md animate-slide-up-fade space-y-6">
        <div className="rounded-2xl border bg-card/60 text-card-foreground shadow-lg backdrop-blur-md p-8 text-center space-y-6">
          <img
            src={isDark ? '/polymyth_logo_v1_final_dark.svg' : '/polymyth_logo_v1_final_lite.svg'}
            alt="Polymyth"
            className="h-12 w-auto max-w-full mx-auto drop-shadow-lg"
          />

          <h1 className="text-3xl text-foreground/90 tracking-wide font-character">
            Polymyth web is designed for a big screen
          </h1>
        </div>

        <div className="rounded-2xl border bg-card/60 text-card-foreground shadow-lg backdrop-blur-md p-8 text-center space-y-6">
          <h2 className="text-3xl text-foreground/90 tracking-wide font-character">
            Play on your phone or tablet
          </h2>

          <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
            <AppStoreBadge />
            <PlayStoreBadge />
          </div>

          <button
            type="button"
            onClick={() => navigate('/')}
            className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to home
          </button>
        </div>
      </div>
    </div>
  );
}
